import React from 'react';
import ReactDOM from 'react-dom/client';
// Webfonts ship for non-Apple platforms; on macOS/iOS the system fallbacks
// (Iowan Old Style for serif) take over for archival headlines.
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';
import './styles/tokens.css';
import './styles/typography.css';
import './index.css';
import App from './App';
import API, { APIContext } from './API';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <APIContext.Provider value={new API()}>
      <App />
    </APIContext.Provider>
  </React.StrictMode>
);
